import { forwardRef, type ButtonHTMLAttributes } from 'react';

export interface PressableProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  /** Pass-through for styling hooks like `data-done`. */
  [dataAttr: `data-${string}`]: string | number | boolean | undefined;
}

/**
 * Pressable — the design system's bare `<button type="button">`.
 *
 * Deliberately UNSTYLED: for one-off tap targets whose look is bespoke
 * (whole-card doors, brand-matched CTAs) but whose semantics shouldn't be
 * hand-rolled raw HTML in feature code. The consumer owns ALL styling —
 * including :hover, :active and :focus-visible — via className.
 *
 * If the same look appears in a second place, stop: promote it to a real
 * primitive instead of sharing a Pressable class.
 */
export const Pressable = forwardRef<HTMLButtonElement, PressableProps>(
  function Pressable(props, ref) {
    return <button ref={ref} type="button" {...props} />;
  },
);
